<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="head-img">
            <div class="head_avater flex-row">
              <div class="top-img">
                <img :src="memberList.headImgUrl ? memberList.headImgUrl : headImg" alt="" style="width: 50px;height: 50px;border-radius: 50%;">
              </div>
              <div class="ml10">
                  <div class="mb10">{{memberList.nickName}} {{memberList.mobile ? memberList.mobile : memberList.idCardNo}}</div>
                  <div class="flex-row">
                    <div class="color666">来源门店：{{memberList.shopName}}</div>
                    <div class="color666 ml10">可用余额： <span class="moneys">￥{{memberList.walletAmount}}</span></div>
                  </div>
              </div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>消费明细</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">{{listSelected.categoryName}}</div>
              <div class="itemNum moneys">{{ listSelected.amount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">已收金额</div>
              <div class="itemNum">{{ listSelected.realPayAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">剩余应收金额</div>
              <div class="itemNum">{{ listSelected.leftAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">已收款次数</div>
              <div class="itemNum">{{ listSelected.repairPayRecordSize }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">收款金额</div>
               <div class="inputs">
                  <el-input
                    class="input"
                    v-model="form.orderAmount"
                    placeholder="请输入收款金额"
                    maxlength="8"
                    @keyup.native="form.orderAmount = isMoney(form.orderAmount)"
                  ></el-input>
                </div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">服务技师</div>
              <div class="itemNum">
                <span v-if="staffNames != ''" @click="setStaff" class="shopClass checkShop">{{ staffNames }}></span>
                <span v-else @click="setStaff" class="shopClass checkShop">请选择></span>
              </div>
            </div>
          </div>
          <div class="pay-methods mt60">
            <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>请选择收款方式</i></p>
            <div class="plr24 flex-row wraps">
              <div class="flex-row orderPayRadio active">
              
                <div class="pay-img"><img :src="listSelected.payWayImgUrl" alt /></div>
                <div class="fontSize16">{{listSelected.payWayCn}}</div>
                <div class="payCheak"><img src="../../../assets/images/new/payRadio.png" alt=""></div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <div class="flex-row">
              <p class>实收金额：</p>
              <p class="amount money">￥{{ form.orderAmount || 0 }}</p>
            </div>
            <el-button type="primary" class="small-btn" @click="saveMoney">确定收款</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <payDialog
      title="支付效验"
      :bizType="'pay'"
      :hide="dialogHide"
      :oid="listSelected.id + ''"
      :memberId="memberList.id"
      :price="Number(form.orderAmount)"
      :type="'repair'"
      :mobile="memberList.mobile"
      @changeDialog="savePay"
    ></payDialog>
    <pay-form ref="payEditForm" @payFun="payMoney" :amount="Number(form.orderAmount)" :foot="true"></pay-form>
    <quickTopUp ref="topUpForm" @handleChange="gotoTopUpPage" :isYuanJian="memberList.yuanjianTransferFlag"></quickTopUp>
    <member-top-up ref="memberTopUpForm" @memberChange="changeTopUp"></member-top-up>
    <staff-set ref="staffSetForm" :isCashier="true"  @staffChange="changePage"></staff-set>
    <confimDdialog ref="confimFrom" @handleChange="cashBack" :money="form.orderAmount" :payWay="form.payWay" :payWayDescription="form.payWayDescription"></confimDdialog>
    <yuan-jian-pay ref="yuanJianForm" @change="yuanJianChange"></yuan-jian-pay>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import payDialog from "../../components/pay-dialog";
import payForm from "../../components/pay";
import quickTopUp from "../../components/quick-top-up";
import memberTopUp from "../member/topUp";
import confimDdialog from "../../components/confim-dialog";
import staffSet from "../../components/staff-set";
import drawer from "../../../components/common/drawer";
import YuanJianPay from '../../components/yuanJianPay.vue';
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { payDialog, quickTopUp, drawer, payForm, memberTopUp , staffSet ,confimDdialog, YuanJianPay},
  data() {
    return {
      radio: "cash",
      addEditTitle: "继续支付",
      addEditShow: false,
      memberList: {
        mobile: ""
      },
      headImg: require("../../../assets/images/new/searchMore.png"),
      payWayList: [],
      mainHeight: this.$store.getters.MainHeight,
      listSelected: [],
      form: {
        orderAmount: "",
		payWayDescription:"现金",
		onlineType:"",
      },
      dialogHide: false,
      amount: 0,
      staffNames: ""
    };
  },
  created() {},
  mounted() {
    this.inits();
  },
  methods: {
    handleChangeDrawer() {
        
      this.form.orderAmount = "";
      this.form.staffIds = "";
      this.form.staffNames = "";
      this.staffNames = "";
      this.addEditShow = false;
    },
    inits() {
      this.$on("set", function(org) {
        this.addEditShow = true;
            console.log(org);
        this.getMember(org.memberId)
        this.$api.get(this.$url.repairDocument.get, {
            id: org.id
        }).then(res => {
            if (res) {
              this.listSelected = res;
              this.form.payWay = res.payWay;
			  this.form.payWayDescription=res.payWayCn;
			  this.form.onlineType=res.onlineType;
            }
        });
        
        
      });
    },
    getMember (id) {
        // 获取会员信息
        this.$api.get(this.$url.member.get, {id: id}).then(res => {
          if (res) {
            console.log(res);
            this.memberList = res;
          }
        })
        .catch(error => {});
    },
    cashBack (val) {
        // 现金确定弹窗回调
        if (val) {
          this.form.millisecond = new Date().getTime();
          console.log(this.form)
          this.$api.post(this.$url.repairDocument.payRepairSingle, encrypt(JSON.stringify(this.form))).then(res => {
              if (res) {
                this.staffNames = "";
                
                localStorage.removeItem("payMobile");
                this.$refs["payEditForm"].$emit("set", res);
              }
          })
        }
    },
    changeTopUp(org) {
      let a = JSON.parse(localStorage.getItem("payMobile"))
      if (org) {
        this.$api.get(this.$url.member.search, {keyword: a.mobile,
            needIntegralFlag: true}).then(res => {
          if (res) {
            this.memberList = res.memberList[0];
          }
        })
      }
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {single: true, staffIds: this.form.staffIds, index: 0});
    },
    gotoTopUpPage(org) {
      if (org && org != 'yuanjian') {
        this.$refs["memberTopUpForm"].$emit("set", this.memberList.id);
      } else if (org && org == 'yuanjian') {
        // yuanjianTransferFlag: true
        // this.$refs["yuanJianForm"].$emit("set", this.memberList);
        let obj = {
          payPrice: this.form.orderAmount,
          memberId: this.memberList.id,
          type: 'repair'
        }
				// this.memberList.payPrice = (Number(this.parentForm.realPayAmount) - Number(this.parentForm.couponAmount || 0)).toFixed(2);
				this.$refs['yuanJianForm'].$emit('set', obj)
      }
    },
    changePage(org) {
        if (org.staffIds.length != 0) {
            this.form.staffIds = org.staffIds[0].staffId;
            this.form.staffNames = org.staffIds[0].staffName;
            this.staffNames = org.staffIds[0].staffName;
        }
    },
    saveMoney() {
        if (!this.form.orderAmount) {
          this.$message.warning("请输入收款金额");
          return false;
        } else if (isNaN(Number(this.form.orderAmount))) {
            this.$message.error("请输入正确的金额");
            return false;
        } else if (!this.staffNames) {
            this.$message.error("请选择技师");
            return false;
        }
        this.form.repairDocId = this.listSelected.id;
        this.form.memberId = this.memberList.id;
        this.form.payCheckType = "";
        this.form.verifyCode = "";

        this.$api.post(this.$url.repairDocument.checkMemberAccountAmount,{
            memberId:this.form.memberId,
            payWay: this.form.payWay,
            realPayAmount: this.form.orderAmount,
            orderType: "repair",
        }).then( res=>{
            if(res.constructor !== Object){
              if (!res) return;
              this.trueToPay();
            }else {
                if (res.status == 'accountAmountInsufficient') {
                  localStorage.setItem("payMobile", JSON.stringify({
                      id: this.form.id,
                      mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
                      path: this.$route.path,
                  }));
                  this.$refs["topUpForm"].$emit("set", "0");
                }
            }
        }).catch( error =>{})
    },
    trueToPay() {
      if (this.form.payWay == 'cash' || this.form.onlineType=='offline') {
            return this.$refs["confimFrom"].$emit("set", true);
        }
        if (this.memberList.walletAmount < this.form.orderAmount) {
            localStorage.setItem("payMobile", JSON.stringify({
                id: this.form.id,
                mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
                path: this.$route.path,
            }));
            this.$refs["topUpForm"].$emit("set", "0");
            return false;
        }
        this.dialogHide = true;
    },
    payMoney(org) {
        if (org) {
          this.form = {
            orderAmount: ""
          };
          this.addEditShow = false;
          this.$emit("change", true)
        }
    },
    savePay(value) {
      if (value != "") {
        this.form.payCheckType = value.payCheckType;
        this.form.verifyCode = value.verifyCode;
        this.form.millisecond = new Date().getTime();
        this.$api.post(this.$url.repairDocument.payRepairSingle,encrypt(JSON.stringify(this.form)))
          .then(res => {
            if (res) {
              this.staffNames = "";
              this.dialogHide = false;
              this.isPayWayHide = false;
              localStorage.removeItem("payMobile");
              // this.$refs["payEditForm"].$emit("set", true);
              this.$refs["payEditForm"].$emit("set", res);
              // this.$router.push(`/collectMoney/components/pay/${res}`);
              // this.$router.push(`/collectMoney/components/pay/${res}`);
            } else {
              this.isPayWayHide = true;
              this.dialogHide = false;
            }
          });
      } else {
        this.dialogHide = false;
      }
    },
    yuanJianChange (org) {
      if (org) this.getMember(this.memberList.id);
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.head-img {
  margin: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  .head_avater {
    width: 100%;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid #EEEEEE;
  }
}
.drawer-footer {
  .btns {
    display: flex;
    padding-bottom: 10px;
    padding-right: 24px;
    .flex-row {
      align-items: center;
      margin-right: 40px;
      font-weight: 500;
      font-size: 16px;
      .money {
        color: @money;
      }
    }
  }
}
.pay-methods {
    border-top: 10px solid #F5F5F5;
    margin-top: 20px;
    .orderPayRadio {
      box-sizing: border-box;
      width: 32%;
      height: 56px;
      background: #FFFFFF;
      border: 1px solid #DCDEE0;
      border-radius: 4px;
      align-items: center;
      padding-left: 16px;
      cursor: pointer;
      position: relative;
      margin-right: 2%;
      margin-bottom: 10px;
      &:nth-of-type(3n) {
        margin-right: 0 !important;
      }
      .payCheak {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .pay-img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .active {
      
      color: #3388FF;
      border: 1px solid #3388FF;
      background: #EAF4FE;
    }
  }
</style>